import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useEffect, useState } from 'react';

export interface NamePromptModalProps {
  open: boolean;
  name: string | null;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setName: React.Dispatch<React.SetStateAction<string | null>>;
  sendClicked: () => Promise<void>;
}

export const NamePromptModal = (props: NamePromptModalProps) => {
  const sendDisabled = !props.name || props.name.length < 2;
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    props.setName(null);
    props.setOpen(false);
  };

  useEffect(() => {
    if (!props.open) {
      setSubmitting(false);
    }
  }, [props.open]);

  return (
    <Dialog open={props.open} onClose={close} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0
        data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left
            shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300
            data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm
            sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <input
              type="text"
              max={30}
              value={props.name ?? undefined}
              onChange={(e) => {
                props.setName(e.target.value);
              }}
              className="w-full rounded-lg border border-gray-300 bg-white
                shadow-[0px_1px_2px_0px_rgba(16,_24,_40,_0.05)] focus:outline-none text-gray-900
                placeholder-gray-400 text-sm"
              placeholder="Enter your name..."
            />
            <div className="mt-5">
              <button
                type="button"
                disabled={sendDisabled}
                onClick={() => {
                  setSubmitting(true);
                  props.sendClicked();
                }}
                title={sendDisabled ? 'Please tell us who you are :)' : undefined}
                className="inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white
                shadow-sm disabled:bg-indigo-300 disabled:cursor-not-allowed disabled:opacity-50 bg-indigo-600
                  hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                  focus-visible:outline-indigo-600"
              >
                {submitting ? '...' : 'Send'}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
